import { useContext } from 'react';
import ImageNodeTabContent from './ImageNodeTabContent';
import NodeBubbleMenuShell from '../../../components/NodeBubbleMenuShell';
import DocumentContext from '../../../contexts/DocumentContext.context';
import { ETiptapSelectorKey } from '../../../types/tiptap.types';

const ImageNodeBubbleMenu = () => {
  const { editor, isEdit, isImageMenuOpen, setIsImageMenuOpen } = useContext(DocumentContext);

  // Right-click only (controlled): selecting an image must not open the menu; the right-click
  // plugin flips isImageMenuOpen and the shell toggles the menu via its show/hide transaction.
  return (
    <NodeBubbleMenuShell
      nodeName={ETiptapSelectorKey.IMAGE}
      editor={editor}
      isEdit={isEdit}
      isOpen={isImageMenuOpen}
      setIsOpen={setIsImageMenuOpen}
      paddingCard="tight"
    >
      <ImageNodeTabContent />
    </NodeBubbleMenuShell>
  );
};

export default ImageNodeBubbleMenu;
